// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@eisinc/App/SharedStyles/smallHeadingAndTextStyles";
import { productListStyles } from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList";
import Edit from "@eisinc/XDL/Icons/Edit";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

productListStyles.centeringWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 300px;
    `,
};

productListStyles.container = {
    css: css`
        padding-top: 16px;
        margin-top: 16px;
        border-top: 1px solid ${color("common.ui3")};
    `,
};
productListStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: 0 auto;
    `,
};

productListStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 12px;
    `,
};

productListStyles.editShipmentLink = {
    ...createLinkIconStyles({
        icon: Edit,
    }),
};

productListStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};

productListStyles.smallHeadingAndText = {
    ...createHorizontalSmallHeadingAndTextStyles(
        {
            wrapper: {
                css: css`
                    margin-bottom: 12px;
                    width: auto;
                `,
            },
            heading: {
                weight: fontConfig.weight.regular,
                ...fontConfig.singleLineRegular,
                css: css`
                    line-height: ${fontConfig.singleLineRegular.lineHeight};
                `,

            },
            text: {
                weight: fontConfig.weight.medium,
                ...fontConfig.singleLineRegular,
                css: css`
                    line-height: ${fontConfig.singleLineRegular.lineHeight};
                `,
            }
        }
    ),
};
productListStyles.shippingCostWrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
    `,
};
